<template>
    <div class="container boxShadow">
        <h5>
            {{info.title}} <span style="color:red" v-if="info.sign_button!=0">({{info.sign_button==-1?'结束':info.sign_button==1?'已报名':info.sign_button==-2?'报名人数已满':info.sign_button==-3?'报名未开始':info.sign_button==-4?'报名截止':''}})</span>
            <p style="font-size: 13px;color:#999;font-weight: normal;">报名时间：{{info.sign_start_time}} - {{info.sign_end_time}}</p>
            <p style="font-size: 13px;color:#999;font-weight: normal;">活动时间：{{info.start_time}} - {{info.end_time}}</p>
            <p style="font-size: 13px;color:#999;font-weight: normal;">限制人数：{{info.user_limit==0?'不限制':`${info.user_limit}`}}</p>
            <p style="font-size: 13px;color:#999;font-weight: normal;" v-if="info.user_limit>0">报名剩余人数：{{info.remnant_num}}人</p>
        </h5>

        <div class="cont">

            <div>
                <img :src="info.cover" alt="">
            </div>
            <div v-html="info.content"></div>
            <section>
                <autoform :formData="formData" @formChange="formChange"></autoform>

            </section>
        </div>
        <div class="btn btn-primary" :class="info.sign_button!=0?'disabled':''" @click="submit">{{info.sign_button==-1?'结束':info.sign_button==1?'已报名':info.sign_button==-2?'报名人数已满':info.sign_button==-3?'报名未开始':info.sign_button==-4?'报名截止':'报名'}}</div>
    </div>
</template>

<script>
    import autoform from '@/components/autoform'
    export default {
        inject: ['ajax'],
        props: [],
        data() {
            return {
                user: {},
                info: {},
                submitFlag: true,
                name: '',
                tel: '',
                age:"",
                address: '',
                addressList:[],
                formData:[],
                form:{}
            };
        },
        computed: {

        },
        created() {
            let id = this.$route.query.id
            console.log(id)
            this.ajax('/api/act/info', 'get', {id:id}, res => {
                this.info = res.data.data.data
                this.addressList = res.data.data.address
                this.formData = res.data.data.fieldsList
            })
        },
        mounted() {

        },
        watch: {

        },
        methods: {
            formChange(data){
                console.log(data)
                this.form = {...data}
            },
            submit() {
                if (this.info.sign_button == 0) {
                    if (this.submitFlag) {
                        this.submitFlag = false
                        let params = this.form
                        params.id = this.$route.query.id
                        this.submitFlag = true
                        this.ajax('/api/act/sign', 'post', this.$qs.stringify(params), res => {
                            this.$alert('报名成功', () => {
                                this.submitFlag = true
                            })
                        })
                    }
                }
            }
        },
        components: {
            autoform
        },
    };
</script>

<style scoped>
    .container {
        background: #fff;
        padding: 50px;
    }

    .container>h5 {
        font-size: 1.3em;
        color: #333333;
        text-align: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
    }

    .cont {
        padding: 15px 0;
    }
    .disabled{
        background: #dceaea;
    }
    @media only screen and (max-width: 750px) {
        .container>h5 {
            font-size: 1em;
            padding-bottom: 0.1rem
        }

        .cont .item {
            width: 100%
        }

        .container {
            padding: 0.15rem;
            font-size: 0.14rem;
        }
    }

    .container {
        background: #fff;
        padding: 50px;
    }

    .container>h5 {
        font-size: 1.3em;
        color: #333333;
        text-align: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
    }

    .cont {
        width: 36.3em;
        margin: 20px auto;
    }

    .cont>h6 {
        font-size: 1em;
        color: #333;
        font-weight: bold;
        text-align: center;
    }

    .cont>h6>span {
        color: #0677e4;
        font-style: italic;
    }

    .cont>section {
        padding: 20px 74px 0;
    }

    .cont .btn {
        width: 100%;
        line-height: 45px;
        height: 45px;
        ;
    }

    .field {
        min-height: 60px;
        padding: 5px 0;
    }

    .field input[type="text"],
    .field input[type="number"] ,select{
        font-size: 1em;
        border: 1px solid #cfcfcf;
        width: 100%;
        line-height: 45px;
        padding: 5px 10px;
        border-radius: 7px;
        height: 45px;
        outline: none;
        color: #a3a3a3;
    }

    .field p {
        color: #666666;
        font-size: 0.9em;
        margin-bottom: 5px;
    }

    .field p>span {
        color: red;
    }

    .field>label {
        font-size: 0.8em;
        color: #b2b2b2;
    }

    .blue {
        color: #42adff;
    }

    .idcard {
        display: flex;
        justify-content: space-between;
    }

    .idcard p {
        color: #999;
        width: 47%;
        height: 140px;
        border-radius: 7px;
        border: 1px solid #cfcfcf;
        color: #aaaaaa;
        text-align: center;
        line-height: 140px;
        font-size: 1.1em;
        position: relative;
        overflow: hidden;
    }

    .idcard p img {
        width: 100%;
        height: 100%;
        object-fit: cover
    }

    input[type="file"] {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
    }

    .btn {
        margin-top: 15px;
    }

    @media only screen and (max-width: 750px) {
        .container>h5 {
            font-size: 1em;
            padding-bottom: 0.1rem
        }

        .cont .item {
            width: 100%
        }

        .container {
            padding: 0.15rem;
            font-size: 0.14rem;
        }

        .cont {
            width: 100%;
        }

        .cont>section {
            padding: 0 0.15rem;
        }

        .field input[type="text"],
        .field input[type="number"] {
            height: 0.35rem;
            line-height: 0.35rem
        }

        .idcard p {
            height: .8rem;
            line-height: .8rem;
            overflow: hidden;
        }
    }
</style>